import { render, staticRenderFns } from "./SliderFull.vue?vue&type=template&id=b10c794e&scoped=true"
import script from "./SliderFull.vue?vue&type=script&lang=js"
export * from "./SliderFull.vue?vue&type=script&lang=js"
import style0 from "./SliderFull.vue?vue&type=style&index=0&id=b10c794e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c794e",
  null
  
)

export default component.exports